import {RsvpStatus} from '@wix/events-types'
import {AnyAction} from 'redux'
import {
  CHANGE_RESPONSE_OLD,
  EDIT_RSVP_STEP_OLD,
  NEXT_RSVP_STEP_OLD,
  SET_RSVP_DETAILS_OLD,
  changeResponse,
  editRsvpStep,
  nextStep,
  setRsvpDetails,
} from '../actions/rsvp'
import {RSVP_STEPS} from '../constants/constants'
import {RsvpState} from '../types/state'

const defaultState: RsvpState = {
  currentStep: RSVP_STEPS[0],
  rsvpDetails: null,
  response: RsvpStatus.YES,
}

export const rsvp = (state = defaultState, action: AnyAction): RsvpState => {
  switch (action.type) {
    case SET_RSVP_DETAILS_OLD:
      return {
        ...state,
        rsvpDetails: action.payload.rsvpDetails,
      }
    case setRsvpDetails.toString():
      return {
        ...state,
        rsvpDetails: action.payload,
      }
    case NEXT_RSVP_STEP_OLD:
    case nextStep.fulfilled.toString():
      return {
        ...state,
        currentStep: action.payload.nextStep,
      }
    case EDIT_RSVP_STEP_OLD:
      const {currentStep} = action.payload
      return {
        ...state,
        currentStep,
      }
    case editRsvpStep.toString():
      return {
        ...state,
        currentStep: action.payload,
      }
    case CHANGE_RESPONSE_OLD:
      return {
        ...state,
        response: action.payload.response,
      }
    case changeResponse.toString():
      return {
        ...state,
        response: action.payload,
      }
    default:
      return state
  }
}
